import React from "react";
import { Button } from "@mui/material";
import { FcGoogle } from "react-icons/fc";
import { signInWithGoogle } from "../../../helpers/firebase";
import { toast } from "react-toastify";

const GoogleButton = () => {

    const handleGoogleButton = () => {
        signInWithGoogle(({user, error}) => {
            if (error === null) {
                toast.success("Utilizador autenticado com sucesso!");
            }
            else {
                let message;
                switch (error.code) {
                    case "auth/popup-closed-by-user":
                        message = "O processo de autenticação foi interrompido pelo utilizador.";
                        break;
                    case "auth/cancelled-popup-request":
                        message = "Foram detetadas múltiplas tentativas de autenticação. Por favor, tenta novamente.";
                        break;
                    case "auth/popup-blocked":
                        message = "O browser bloqueou a janela de autenticação. Por favor, permite popups deste site e tenta novamente.";
                        break;
                    case "auth/operation-not-allowed":
                        message = "O método de autenticação não está ativo. Por favor, contacta-nos.";
                        break;
                    case "auth/user-disabled":
                        message = "O utilizador foi desativado. Por favor, contacta-nos.";
                        break;
                    case "auth/account-exists-with-different-credential":
                        message = "Já existe uma conta com o mesmo endereço de email mas com credenciais de autenticação diferentes. Por favor, utiliza um método de autenticação diferente.";
                        break;
                    default:
                        message = "Ocorreu um erro ao entrar na conta. Por favor, tenta novamente mais tarde ou contacta-nos.";
                        break;
                }
                toast.error(message, {autoClose: 8000});
            }
        });
    }

    return (
        <Button startIcon={<FcGoogle />} color="primary" variant="outlined" fullWidth onClick={handleGoogleButton}>
            Entrar com o Google
        </Button>
    );
}

export default GoogleButton;
